// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/TaskView/WorkPlace/Workplace.css
// module id = 1641
// module chunks = 0